<template lang="html">

  <div class="recursos-view" >

    <!-- <h2 >{{$t('encabezado.recursos')}}</h2> -->
    <encabezado :data="'recursos'" v-if="!esHome"></encabezado>
    
    <filtro v-if="!esHome"></filtro>
    
    <div class="container">
      <div class="row cont-recurso" v-if="lRecursosFilter.length>0" >
        <template v-for="(recurso, key) in ((!esHome && lRecursosFilter.length > numMaxPagina) ? lRecursosFilter.slice(((paginaActual-1) * numMaxPagina), (((paginaActual-1) * numMaxPagina)+numMaxPagina)) : lRecursosFilter)" style="margin:15px;">
          <recurso-el :data="recurso"></recurso-el>
        </template>
        <div class="row ver-mas-cont" v-if="esHome">
          <arrow-link class="arrow-link" :text="'VER TODOS LOS RECURSOS'" :to="$t('enlaces.recursos')" :external="false" :blank="false">
          </arrow-link>
        </div>
      </div>
      <h1 class="row cont-recurso" style="display:block;text-align:center;" v-else >
        No hay recursos para mostrar
      </h1>

    </div>

    <!-- PAGINACION -->
    <template v-if="!esHome && lRecursosFilter.length > numMaxPagina">
      <div>
        <button class="btn -skull-primary -pagina-siguiente" @click="paginaAnterior"><</button>
        Página {{paginaActual}} de {{numPaginas}}
        <button class="btn -skull-primary -pagina-siguiente" @click="paginaSiguiente">></button>
      </div>
    </template>

    <modulo-orientacion-info v-if="!esHome" :esHome="false"></modulo-orientacion-info>

    <modulo-orientacion-solicitar v-if="!esHome"></modulo-orientacion-solicitar>

  </div>

  <!-- <loading v-else-if="!esHome"></loading> -->

</template>

<script lang="js">

  import encabezado from '@/components/parts/encabezado';

  import {mapGetters, mapActions} from 'vuex';

  import loadingView from '@/components/parts/loading';

  import router from '@/router';

  import recursoEl from '@/components/views/orientacion/recurso-el'
  
  import arrowLink from '@/components/parts/icons/arrow-link';

  import filtro from '@/components/views/orientacion/filtro-recursos'
  import moduloOrientacionInfo from '@/components/views/home/modulo-orientacion-info';
  import moduloOrientacionSolicitar from '@/components/views/home/modulo-orientacion-solicitar';
  
  export default  {
    name: 'recursos',
    props :['esHome','excluirIdRecurso'],
    components : {
      'encabezado' : encabezado,
      'loading' : loadingView,
      'recurso-el' : recursoEl,
      'arrow-link': arrowLink,
      'filtro' : filtro,
      'modulo-orientacion-info': moduloOrientacionInfo,
      'modulo-orientacion-solicitar': moduloOrientacionSolicitar
    },
    mounted(){
      // this.getActualidad(this.isEmpresa).then(r => {
      //   this.lRecursos = r;
      //   this.loading = false;
      // })
    },
    data(){
      return {
        loading: true,
        numMaxPagina: 15,
        paginaActual: 1,
        numPaginas: 1,
      }
    },
    methods: {
      ...mapActions([
      ]),
      paginaAnterior: function () {
        if(this.paginaActual > 1)
          this.paginaActual = this.paginaActual - 1;
      },
      paginaSiguiente: function () {
        if(this.paginaActual < this.numPaginas)
          this.paginaActual = this.paginaActual + 1;
      }
    },
    watch : {
      'filtrosData' : function(){
        
      }
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        isEmpresa : 'isEmpresa',
        lRecursos : 'getRecursos',
        filtrosData : 'getfiltrosrecursos'
      }),
      lRecursosFilter : function(){
        if (this.lRecursos!=null && this.lRecursos.length>0){
          
          var lRecursosFiltrados = this.lRecursos;

          if (this.esHome) {

            //Si excluirIdRecurso tiene valor, entonces lo filtramos también, porque estamos en la vista de ese recurso y estamos enseñando
            //recursos en la seccion "Te puede interesar", y no tenemos que mostrar el propio
            if (this.excluirIdRecurso != null && this.excluirIdRecurso != '') {
              lRecursosFiltrados = lRecursosFiltrados.filter((r) => (r.idRecurso.toString() != this.excluirIdRecurso.toString() ));
            }
            
            return lRecursosFiltrados.slice(0, 3);

          }else{

            if (this.filtrosData.text != null && this.filtrosData.text != '') {
              lRecursosFiltrados = lRecursosFiltrados.filter((r) => (r.titulo.toLowerCase().includes(this.filtrosData.text.toLowerCase())));
            }

            if (this.filtrosData.tipo != null && this.filtrosData.tipo != '') {
              lRecursosFiltrados = lRecursosFiltrados.filter((r) => (r.idTipoCategoria == this.filtrosData.tipo));
            }

            this.paginaActual=1;
            this.numPaginas=Math.ceil(lRecursosFiltrados.length / this.numMaxPagina);

            return lRecursosFiltrados;
          }

        }else{
          return [];
        }
      }
    },
  }
</script>

<style scoped lang="scss">

  .recursos-view > .container{
    max-width: calc(100% - 300px);
  }
    
  @media screen and (max-width: 1800px){
    .recursos-view > .container{
      max-width: calc(100% - 150px);
    }
  }

  @media screen and (max-width: 1500px){
    .recursos-view > .container{
      max-width: calc(100%);
    }
  }


  h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-top: 100px;
    color: #386DB0;
  }

  .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .col-lg-4, .col-sm-6, .col-xs-12{
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }
  @media (max-width: 680px) {
    .col-xs-12 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  @media (min-width: 680px) {
    .col-sm-6 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
  @media (min-width: 992px) {
    .col-lg-4 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }
  
  .selector-tipo{
    margin-top: 50px;
  }

  .wrapper-filtro{
    margin-bottom: 0;
  }

  .status{
    border: none;
    outline: none;
    background-color: transparent;
    padding-left: 0;
    height: 30px;
    line-height: 30px;
    font-weight: 700;
    margin: 0 25px;
    cursor:pointer;
    opacity: .7;
  }

  .status[active="true"]{
    text-decoration: underline;
    opacity: 1;
  }

  @media screen and (max-width: 767px){

    .selector-tipo{
      margin-top: 25px;
    }

    .selector-tipo a{
      border-right: none;
      padding-right: 5px;
      margin-right: 5px;
      font-size: 12px;
    }


  }


  @media screen and (max-width: 380px){
    .selector-tipo a{
      padding-right: 3px;
      margin-right: 3px;
      font-size: 12px;
    }
  }


  @media screen and (max-width: 330px){
    .selector-tipo a{
      padding-right: 4px;
      margin-right: 4px;
      font-size: 10px;
    }
  }

  @media screen and (max-width: 500px){
    .status{
      margin: 0 10px;
    }
  }

  .btn-not-container{
    margin: 40px;
  }

  .-skull-primary{
    height: 43px;
    width: 156px;
  }

  .-solid-primary{
    height: 40px;
    width: 160px;
  }

  .cont-recurso{
    margin: 60px 200px;

    .ver-mas-cont{
      width: 100%;
      display: inline;
      text-align: center;

      .arrow-link{
        width: 100%;
        left: 50px;
        top: 25px;
        position: relative;
        color: #386DB0;
      }
    }
  }  

  @media screen and (max-width: 1400px){
    .cont-recurso{
      margin: 60px 40px;
    }
  }  

  @media screen and (max-width: 400px){
    .cont-recurso{
      margin: 60px 10px;
    }
  } 

  .-pagina-siguiente{
    min-width: 15px;
    max-width: 70px;
    margin: 0 10px;
    font-size: 18px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/orientacion/recursos.vue